import React, {Component} from 'react';
import { Button } from 'antd';
//import { connect } from 'dva';
import Animate from 'react-move/Animate';
import { easeExpOut } from 'd3-ease';
//import BaseComponent from './BaseComponent';
//import Dimio from './Dimio';
//import Request from 'superagent';
import _ from 'lodash';

class DimioSlidein extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.openPanel = this.openPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
  }

  componentDidMount() {
    const {isOpen} = this.props;
  }

  togglePanel(){
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  openPanel(){
    this.setState({
      isOpen: true
    });
  }

  closePanel(){
    this.setState({
      isOpen: false
    });
  }

  /**
   * props
   * - fromLeft: default true
   * - fromRight: default false
   * - top:0
   * - width
   * - closeButton
   * @returns {*}
   */
  render() {
    const {top=0, width, fromRight, closeButton=true} = this.props;
    const {isOpen} = this.state;
    const w = (width)?width:window.innerWidth;
    const initPos = (fromRight)?w:w * -1;

    const from = fromRight?'right:0':'left:0';

    return (
      <div>
        <Animate
          start={() => ({
            x: initPos,
          })}

          update={() => ({
            x: [isOpen ? 0: initPos],
//            timing: { duration: 750, ease: easeExpOut },
          })}
        >
          {(state) => {
            const { x } = state;
            const style = {
              width:`${w}px`,
              height:'100%',
              top:`${top}px`,
              WebkitTransform: `translate3d(${x}px, 0, 0)`,
              transform: `translate3d(${x}px, 0, 0)`,
            };
            if(fromRight){
              style.right = 0;
            }else{
              style.left = 0;
            }

            return(
              <section style={style} className='dimio-slide-panel'>
                {closeButton &&
                <Button
                  onClick={this.closePanel}
                  className='btn-close'
                  type='primary'
                  icon='close'></Button>
                }

                {this.props.children}
              </section>
            )
          }}
        </Animate>
      </div>
    )
  }
}

export default DimioSlidein;


// WEBPACK FOOTER //
// ./src/components/DimioSlidein.js